import { defineComponent, PropType } from 'vue';

import { FIELD_VALUE_UPDATED } from "../../events";
import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { AutoCompleteTextField2Modal } from '../auto-complete-text-field2-modal';

export const AutoCompleteTextField2 = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAutoCompleteTextField2Modal: AutoCompleteTextField2Modal,
    },
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    template: require("./auto-complete-text-field2.html"),
    data() {
        return {
            FIELD_VALUE_UPDATED,
        }
    },
    computed: {
        valueCopy: {
            get(): String {
                return this.value ?? ""
            },
            set(newValue: String) {
                this.$emit(FIELD_VALUE_UPDATED, newValue)
            },
        },
    },
    methods: {
        onValueFromModal(value: string) {
            this.valueCopy = value
        },
        openModal() {
            if(!this.readonly) {
                (this.$refs.modal as InstanceType<typeof AutoCompleteTextField2Modal>).openModal()
            }
        },
    },
})
